import {RESET_FORM_ACTION} from "./resetFormType";

export const resetFormAction = () => {

    return {
        type: RESET_FORM_ACTION
    }

}